import { z } from 'zod'

export const envSchema = z.object({
  VITE_123FALA_URL: z.string().url(),
  VITE_FALAZAP_URL: z.string().url(),
  VITE_AZURE_CLIENT_ID: z.string().min(1),
  VITE_AZURE_TENANT_ID: z.string().min(1),
  VITE_BUBBLE_API_URL: z.string().url(),
  VITE_BUILDER_EMBED_URL: z.string().url(),
  VITE_CAMPAIGN_API_URL: z.string().url(),
  VITE_CAMPAIGN_DISPATCHER_URL: z.string().url(),
  VITE_CONVERSATIONS_API_URL: z.string().url(),
  VITE_FALAZAP_PREVIEW_URL: z.string().url(),
  VITE_FINN_URL: z.string().url(),
  VITE_FINTALK_BACKOFFICE_URL: z.string().url(),
  VITE_FINTALK_ENV: z.enum(['dev', 'prd']),
  VITE_FOLLOWUP_DISPATCHER_URL: z.string().url(),
  VITE_GITHUB_SHA: z.string().optional(),
  VITE_N8N_DEV_EMBED_URL: z.string().url(),
  VITE_N8N_STG_EMBED_URL: z.string().url(),
  VITE_N8N_PRD_EMBED_URL: z.string().url(),
  VITE_PROXY_URL: z.string().url(),
  VITE_SENTRY_DSN: z.string().url(),
  VITE_SSO_URL: z.string().url(),
  VITE_SUPERSET_DOMAIN: z.string().url(),
})
